const carouselOneTiles = document.querySelectorAll('section[analytics_context="homepage_carousel_1"] li a');
const carouselTwoTiles = document.querySelectorAll('[analytics_context="homepage_carousel_2"] li a');
const carouselThreeTiles = document.querySelectorAll('[analytics_context="homepage_carousel_3"] li a');

const homepageCarouselTiles = [...carouselOneTiles, ...carouselTwoTiles, ...carouselThreeTiles];

homepageCarouselTiles.forEach((link) => {
  link.addEventListener('click', async (ev) => {
    ev.preventDefault();
    const productName = link.getAttribute('data-product');
    const context = link.closest('section')?.getAttribute('analytics_context') || 'unknown_section';
    const product_category = link.closest('section')?.getAttribute('selected_products_category') || 'unknown_section';

    await dataLayerPromise({
      event: 'product_tile_clicked',
      section: context,
      element: 'big_product_tile',
      element_value: productName ? productName : '',
      interaction_type: 'click',
      product_category: product_category,
    });
    continueLinkClickEvent(ev, link.href);
  });
});
